@if(open){
<div
  class="fixed inset-0 bg-black/40 backdrop-blur-sm flex items-end justify-center pb-24 z-50"
>
  <div class="grid grid-cols-2 gap-4 w-[320px]">
    <button
      class="fab-btn bg-[--expenses-background] text-white"
      (click)="action('expense')"
    >
      <span class="text-white">Spesa</span>
      <ion-icon name="add"></ion-icon>
    </button>

    <button
      class="fab-btn bg-[--customer-background]"
      (click)="action('customer')"
    >
      <span>Proprietario</span>
      <ion-icon name="person-add"></ion-icon>
    </button>

    <button
      class="fab-btn bg-[--operator-background] col-span-1"
      (click)="action('operator')"
    >
      <span>Collaboratore</span>
      <ion-icon name="glasses"></ion-icon>
    </button>

    <button
      class="fab-btn bg-[var(--primary-text-color)] text-white"
      (click)="action('appointment')"
    >
      <span class="text-white">Appuntamento</span>
      <ion-icon name="calendar"></ion-icon>
    </button>
  </div>
</div>
}
